<template>
    <div class="main noTakeaway red">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Shuffling :swiper="coredata"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: '2021Q2jdcb',
    // meta配置
    metaInfo: {
        title: '【专题】' + '增收未增利 钱去哪了？ 京东2021年二季度净利润下滑近100%',
        meta: [
            {
                name: 'keywords',
                content: '京东 财报 收入 亏损 营收'
            },
            {
                name: 'description',
                content: '8月23日晚，京东发布2021年二季度业绩。业绩显示，2021年第二季度营收为2538亿元人民币，同比增长26.23%。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/2021Q2jdcb/banner2.jpg'),
                title: [
                    '增收未增利 钱去哪了？',
                    '京东2021年二季度净利润下滑近100%',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '京东二季报全文下载',
                    url: 'https://pdf.dfcfw.com/pdf/H2_AN202108231511891966_1.pdf?1629742759000.pdf'
                },
                {
                    title: '【电商快评】增收未增利 京东二季报反映了什么？',
                    url: '/detail--6599828.html'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '图解财报 京东'
                },
            },

            // 核心数据
            coredata: {
                title: {
                    topic: '核心数据',
                    more: {
                        name: '更多数据>',
                        url: '/Index/dsb_product.html',
                    }
                },
                list: [
                    {
                        img: require('@/assets/2021Q2jdcb/cb5.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2jdcb/cb6.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2jdcb/cb7.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2jdcb/cb8.jpg'),
                        url: ''
                    },
                ]
            },

            // 网经社点评
            review: {
                title: {
                    topic: '网经社点评',
                },
                nav: [
                    {
                        value: '曹磊 京东',
                        label: '曹磊'
                    },
                    {
                        value: '莫岱青 京东',
                        label: '莫岱青'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '曹磊 京东'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '行业类',
                    title: '京东'
                },
            }
        }
    },
}
</script>

<style>

</style>
